import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import { PHONE_REGEX } from '../../config/globals';

export const phoneFieldOptions = {
  maxLength: 8,
  registerOptions: {
    required: 'MobilePhoneNumber.error.pattern',
    pattern: {
      value: PHONE_REGEX,
      message: 'MobilePhoneNumber.error.pattern',
    },
    maxLength: {
      value: 8,
      message: 'MobilePhoneNumber.error.length',
    },
    minLength: {
      value: 8,
      message: 'MobilePhoneNumber.error.length',
    },
  },
} satisfies IFieldOptions;
